import Vue from 'vue'
import router from './router/router'
import store from './vuex/store'
import vueResource from 'vue-resource'
import VueNoty from 'vuejs-noty'
import VeeValidate from 'vee-validate';
import MaskedInput from 'vue-text-mask'
import vbclass from 'vue-body-class'
import './utils'

import bootstrapJs from 'bootstrap/dist/js/bootstrap.min'

// import bootstrapDatePicker from 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min'
// import adminLTE from './assets/js/adminlte/adminlte.min'
import functions from './assets/js/functions'
import BootstrapVue from 'bootstrap-vue'
import Spinner from 'vue-simple-spinner'
import VTooltip from 'v-tooltip'
import VueAnalytics from 'vue-analytics'
import './utils/utils'

Vue.use(VTooltip)

Vue.use(vueResource)
Vue.use(VeeValidate, {fieldsBagName: 'veeFields'});
Vue.use(MaskedInput);
Vue.use(vbclass, router)
Vue.use(VueNoty, {
  theme: 'relax',
  timeout: 5000,
  progressBar: true,
})
Vue.use(BootstrapVue);
Vue.use(VueAnalytics, {
  id: 'UA-19555861-17',
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production',
    router
  }
})

/*Déclaration des composants globaux */
Vue.component('masked-input', MaskedInput)
Vue.component('vue-simple-spinner', Spinner)
//TODO to false
Vue.config.productionTip = false

/*HEADERS & PROTYPE*/
Vue.prototype.$consoleLog = function () {
  console.log(...arguments)
}

/*FILTERS*/
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('uppercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

/* App sass */
import './assets/scss/style.scss'

/* APP Component */
import App from './App'

/* Auth plugin */
import Auth from './auth'

Vue.use(Auth)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // Attach the Vue instance to the window,
  // so it's available globally.
  created: function () {
    window.Vue = this
  },
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js